import { apiServices } from "../../../../core/utilities/ApiServices";
import { Chats } from "../../domain/entities/getChat";
import { ChatMessage } from "../../domain/entities/getMessages";
import { ChatMessageParams } from "../../domain/entities/getMessagesParams";
import { UploadFileProps } from "../../domain/entities/uploadFile";

export interface ChatDataSource {
	getChats(): Promise<Chats[]>;
	getMessages(data: ChatMessageParams): Promise<ChatMessage[]>;
	clearChat(chat_id: string): Promise<void>;
	uploadFile(params: UploadFileProps): Promise<void>;
}

export class ChatDataSourceImpl implements ChatDataSource {
	async getChats(): Promise<Chats[]> {
		const response = await apiServices.get(`/chat/chats`);
		if (response.status === 200) {
			return response.data;
		} else {
			throw new Error();
		}
	}

	async getMessages(data: ChatMessageParams): Promise<ChatMessage[]> {
		const response = await apiServices.get(`/chat/messages`, {
			params: {
				chat_id: data.chat_id,
				page: data.page,
				limit: data.limit,
			},
		});
		if (response.status === 200) {
			return response.data;
		} else {
			throw new Error();
		}
	}
	async clearChat(chat_id: string): Promise<void> {
		const response = await apiServices.delete(`/chat/clear`, {
			params: {
				chat_id: chat_id,
			},
		});
		if (response.status === 200) {
			return;
		} else {
			throw new Error();
		}
	}

	async uploadFile(params: UploadFileProps): Promise<void> {
		const formData = new FormData();
		formData.append("chat_id", params.chat_id);
		formData.append("is_temp", `${params.is_temp}`);
		formData.append("message_id", params.message_id);
		formData.append("file", params.file);
		const response = await apiServices.post(`/chat/message`, formData, {
			headers: { "Content-Type": "multipart/form-data" }
		});
		if (response.status === 201) {
			return;
		} else {
			throw new Error();
		}
	}
}
